import {
  USAGE_REPORT_PERIOD,
  UsageReportPeriod,
} from 'models/EnterprisesAnalytics';

export const USAGE_REPORT_PERIOD_LABEL_KEYS: Record<UsageReportPeriod, string> =
  {
    [USAGE_REPORT_PERIOD.LAST_WEEK]: 'usageReportLastWeek',
    [USAGE_REPORT_PERIOD.LAST_7_DAYS]: 'usageReportLast7Days',
    [USAGE_REPORT_PERIOD.LAST_MONTH]: 'usageReportLastMonth',
    [USAGE_REPORT_PERIOD.LAST_FULL_QUARTER]: 'usageReportLastFullQuarter',
    [USAGE_REPORT_PERIOD.ALL_TIME]: 'usageReportAllTime',
  };

export const USAGE_REPORT_SECTIONS: Array<{
  titleKey: string;
  descriptionKey: string;
}> = [
  {
    titleKey: 'usageReportSummarySection',
    descriptionKey: 'usageReportSummarySectionDescription',
  },
  {
    titleKey: 'usageReportBusinessUnitsSection',
    descriptionKey: 'usageReportBusinessUnitsSectionDescription',
  },
  {
    titleKey: 'usageReportAdoptionGapSection',
    descriptionKey: 'usageReportAdoptionGapSectionDescription',
  },
];

export type FormValues = { period: UsageReportPeriod };
